import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { DriverActivityResponse, DriverStatus } from '../models/driver-status.model';
import { environment } from '@environments/environment';
import { Asset } from '@app/modules/location-client/location-api.models';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DriverStatusService {
  constructor(private http: HttpClient) {}

  getStatus(accountId: string, vin: string): Observable<DriverStatus> {
    const url = `${environment.locationApi.url}/live/${vin}?accountId=${accountId}`;
    return this.http.get<Asset>(url).pipe(
      map((res: Asset) => {
        if (!res?.vdo1) {
          return null;
        }
        let lastUpdate = null;
        let driverActivity = null;
        if (res.geoEventTs) {
          lastUpdate = Date.parse(res.geoEventTs);
        }
        if (res.driverActivity) {
          driverActivity = res.driverActivity;
        }

        return { lastUpdate, driverActivity, ...res.vdo1 } as DriverStatus;
      })
    );
  }

  getDriverActivity(
    driverCardId: string,
    accountId: string,
    startTime: Date,
    endTime: Date
  ): Observable<DriverActivityResponse[]> {
    const url = `${
      environment.locationApi.url
    }/driver_activity/${driverCardId}?accountId=${accountId}&startTime=${startTime.toISOString()}&endTime=${endTime.toISOString()}`;
    return this.http.get<any>(url);
  }
}
